// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.size-icon[data-v-40bd2e60] {\n  font-size: 20px;\n  cursor: pointer;\n  vertical-align: -4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
